export const steps = [{ label: "Edit Advisor(s)" }, { label: "Preview & Confirm" }];

export const UNASSIGNED = "Unassigned";
